import { constants, mediaQueryStyles } from "@newsela/angelou";

const { mediaQuery } = mediaQueryStyles;
const { sm, md } = constants.breakpoints.BreakpointNames;

export const footerSection = {
  [mediaQuery.upTo(sm)]: {
    paddingTop: 0,
  },
  padding: "40px",
};

export const listCss = {
  display: "inline-block",
  listStyleType: "none",
  marginBlockEnd: 0,
  padding: "8px 0 0 0",
  [mediaQuery.upTo(sm)]: {
    display: "block",
    paddingBottom: 40,
  },
};

export const itemCss = {
  [mediaQuery.upTo(md)]: {
    display: "inline-block",
  },
  [mediaQuery.upTo(sm)]: {
    display: "block",
  },
  display: "inline-block",
  padding: "0 80px 8px 0",
};

export const atagCss = {
  color: "inherit",
  fontSize: "14px",
  textDecoration: "none",
};
